import { render, staticRenderFns } from "./CommonModulePage.vue?vue&type=template&id=7a7e74d2"
import script from "./CommonModulePage.vue?vue&type=script&lang=js"
export * from "./CommonModulePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports